// Module
var code = "<p>[# receive]</p> <h3 id=\"获取-bts\">获取 BTS</h3> <p>为了从其他人或者交易所获得BTS，你只需要提供你的账户名: <strong>{account}</strong></p> <p>[# deposit-short]</p> <h3 id=\"充值提现-数字资产\">充值/提现 数字资产</h3> <p>如果你要充值或提现资产，无论是法币或是来自其他区块链，你需要使用<a href=\"introduction/bridges_gateways\">桥接</a> 或 <a href=\"introduction/bridges_gateways\">网关</a> 服务来实现。你可以从下面找到一系列提供服务的服务商:</p> ";
// Exports
export default code;